<template functional>
  <container-tasks
    :container="{ id: props.item.id, abbrev_type: props.item.abbrev_type }"
    :tasks="props.item.tasks"
  />
</template>

<script>
export default {
  name: "drayage-tasks",
  functional: true,
  props: {
    item: Object,
    options: Object,
  },
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
